var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.s.container }, [
    _c("div", { style: _vm.s.wrapper }, [
      _c("div", { style: _vm.s.title }, [
        _vm._v(_vm._s(_vm.Title)),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ShowClose,
              expression: "ShowClose"
            }
          ],
          style: _vm.s.close,
          on: { click: _vm.close }
        })
      ]),
      _c("div", { style: _vm.s.body }, [
        _vm.isDeleteAll
          ? _c(
              "div",
              [
                _c(
                  "i18n",
                  {
                    staticClass: "strong",
                    attrs: {
                      path: "trade.proxy.dialog.cancelAllTips",
                      tag: "span"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "address_container",
                        attrs: { place: "trustAddress" }
                      },
                      [_vm._v(_vm._s(_vm.trustAddress))]
                    )
                  ]
                )
              ],
              1
            )
          : _c("div", [
              _c("div", { staticClass: "__row" }, [
                _c("div", { staticClass: "__row_t" }, [
                  _vm._v(_vm._s(_vm.$t("trade.proxy.passive.head.0")))
                ]),
                !!_vm.trustAddress
                  ? _c(
                      "div",
                      { staticClass: "__input_row __unuse_input __ellipsis" },
                      [_vm._v(_vm._s(_vm.trustAddress))]
                    )
                  : _vm._e()
              ]),
              _c("div", { staticClass: "__row" }, [
                _c("div", { staticClass: "__row_t" }, [
                  _vm._v(_vm._s(_vm.$t("trade.proxy.passive.head.1")))
                ])
              ]),
              _c(
                "div",
                { staticClass: "block__content" },
                _vm._l(_vm.pairArray, function(t) {
                  return _c("span", { key: t, staticClass: "pure-pair" }, [
                    _vm._v(_vm._s(t))
                  ])
                }),
                0
              )
            ])
      ]),
      _vm.ShowBottom
        ? _c("div", { style: _vm.s.btnGroup }, [
            !!_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.STxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  { style: [_vm.s.lBtn, _vm.s.btn], on: { click: _vm.lClick } },
                  [_vm._v(_vm._s(_vm.LTxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.RTxt))]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }